import { useNavigate } from 'react-router-dom'
import { Button } from '@/components/ui/Button'
import { Card } from '@/components/ui/Card'
import { EmptyState } from '@/components/ui/States'

export function NotFoundPage() {
  const navigate = useNavigate()
  return (
    <Card>
      <EmptyState
        title="That page does not exist"
        description="The link may be stale, or the client it pointed at may have been renamed."
        action={
          <Button size="sm" onClick={() => navigate('/')}>
            Back to all clients
          </Button>
        }
      />
    </Card>
  )
}
